/**
 * KAN-834: подсказка "Добавьте на главный экран" для страницы входа в
 * приложение менеджера. Данные и действие из lib/pwaInstall.
 */
import { useCallback, useSyncExternalStore } from 'react';
import {
  getInstallPrompt,
  installHintKind,
  isAndroidInAppBrowser,
  isIosDevice,
  isStandaloneDisplay,
  promptInstall,
  subscribeInstallPrompt,
  type InstallHintKind,
} from '@/lib/pwaInstall';

export interface InstallPrompt {
  kind: InstallHintKind;
  install: () => Promise<boolean>;
}

export function useInstallPrompt(): InstallPrompt {
  const event = useSyncExternalStore(subscribeInstallPrompt, getInstallPrompt, () => null);
  const kind = installHintKind({
    standalone: isStandaloneDisplay(),
    canPrompt: event !== null,
    ios: isIosDevice(navigator.userAgent, navigator.maxTouchPoints ?? 0),
    inApp: isAndroidInAppBrowser(navigator.userAgent),
  });
  const install = useCallback(() => promptInstall(), []);
  return { kind, install };
}
